import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-00f889d1")

_pushScopeId("data-v-00f889d1")
const _hoisted_1 = { class: "text" }
const _hoisted_2 = { id: "alert-message-list" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TheAlertMessageListItem = _resolveComponent("TheAlertMessageListItem")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("p", _hoisted_1, "Seznam upozornění (" + _toDisplayString(_ctx.alerts.length) + ")", 1),
    _createVNode("ul", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.alerts, (alertItem) => {
        return (_openBlock(), _createBlock("li", {
          key: alertItem.id
        }, [
          _createVNode(_component_TheAlertMessageListItem, {
            "alert-item": alertItem,
            onRemoveAlert: _ctx.removeAlertFromList,
            onEditAlert: _ctx.editAlert,
            onInvokeError: _ctx.invokeError,
            onInvokeSuccess: _ctx.invokeSuccess
          }, null, 8, ["alert-item", "onRemoveAlert", "onEditAlert", "onInvokeError", "onInvokeSuccess"])
        ]))
      }), 128))
    ])
  ], 64))
})